import { Pipe, PipeTransform } from "@angular/core";

/**
 * Standalone-Pipe: Berechnet die verbleibenden Tage bis zu einem Datum.
 */
@Pipe({
  name: 'remainingDays',
  standalone: true
})
export class RemainingDaysPipe implements PipeTransform {

  /**
   * Gets the difference between the given date and the current date in days.
   * @param value The date to get the difference for.
   * @returns The difference in days.
   */
  transform(value: Date) {
    if (value === null || value === undefined) {
      return -1;
    }
    const currentDate = new Date();
    const targetDate = new Date(value);
    const currentDateUTC = Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const targetDateUTC = Date.UTC(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate());
    return Math.floor(targetDateUTC - currentDateUTC) / (1000 * 60 * 60 * 24);
  }

}